import { render, staticRenderFns } from "./insurers-grid.vue?vue&type=template&id=9338be86&scoped=true&"
import script from "./insurers-grid.ts?vue&type=script&lang=ts&"
export * from "./insurers-grid.ts?vue&type=script&lang=ts&"
import style0 from "./insurers-grid.scss?vue&type=style&index=0&id=9338be86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9338be86",
  null
  
)

export default component.exports